import { useState, useEffect } from "react";
import InputWithLabel from "./InputWithLabel";
import Button from "../buttons/button";
import SelectBox from "./SelectBox ";
import moment from "moment";
import useTranslator from "../../../hooks/useTranslator";

const initialFormData = {
  date: "",
  shift: ""
};

const today = moment().format("YYYY-MM-DD");

const CleaningModuleFilter = ({ onApplyFilter, date, onClose, filters = {} }) => {

    const [filtersData, setFiltersData] = useState(initialFormData);
    const { _t } = useTranslator();
    const shifts = [
        {
        label: _t("morning", "Morning"),
        value: "1",
        },
        {
        label: _t("evening", "Evening"),
        value: "2",
        },
    ];

    const handleChange = (e) => {
        setFiltersData({ ...filtersData, [e.target.name]: e.target.value });
    };

    // useEffect(() => {
    //     console.log(filtersData)
    // },[filtersData]);

  const handleReset = (e) => {
    e.preventDefault();
    setFiltersData(initialFormData);
    onApplyFilter(initialFormData);
    if (onClose) {
      onClose();
    }
  };

  const handleApply = (e) => {
    e.preventDefault();
    // console.log(filtersData)
    onApplyFilter({ ...filtersData });
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="dropdown_body">
      <h5 className="mb-3 border-bottom">{_t("filter_heading", "Filter")}</h5>

      <InputWithLabel
        label={_t("entered_date", "Entered Date")}
        type="date"
        name="date"
        value={filtersData.date}
        onChange={handleChange}
      />


      <SelectBox
        label={_t("shifts", "Shifts")}
        name="shift"
        value={filtersData.shift}
        onChange={handleChange}
        options={shifts?.map((list) => ({
          value: list.value,
          label: _t(list.label, list.label),
        }))}
      />

      <div className="d-flex justify-content-between mt-3">
        <Button
          onClick={handleReset}
          label={_t("reset_button", "Reset")}
          className="reset_btn"
        />
        <Button
          className="cmn_btn"
          label={_t("apply_button", "Apply")}
          onClick={handleApply}
        />
      </div>
    </div>
  );
};

export default CleaningModuleFilter;
